function App() {

    const url = new UrlHelper()

    // -- pages where the search and 'dest' logic is taking place. Everything else is static content with plain HTML
    const SEARCH_PAGES = ['/', 'index.html', 'search.html']

    if (!SEARCH_PAGES.includes(url.pathname) && !SEARCH_PAGES.includes(url.pathname.split('/').pop())) {
        return;
    }

    const html = document.querySelector('.content')


    if (url.get('dest')) {
        (async () => {
            try {
                // Build the URL to the destination
                const destUrl = new URL(
                    window.location.protocol + '//' + atob(url.get('dest')))

                const params = []
                new URL(window.location.href).searchParams.forEach((value, key) => {
                    destUrl.searchParams.set(key, value)
                    params.push(key)
                })
                destUrl.searchParams.set('asJson', '1')

                // Fetch the destination URL and get the redirect URL
                fetch(destUrl).then((response) => response.json()).then((response) => {
                    // Delete old params
                    params.forEach((key) => {
                        url.delete(key)
                    })
                    url.delete('dest')

                    // Set new params
                    const newUrl = new URL(response)
                    newUrl.searchParams.forEach((value, key) => {
                        url.set(key, value)
                    })

                    this.search()
                })
            } catch {
            }
        })()
    }

    // -- add a unique track_id to the url if it is not set
    if (!url.getTrackId() && !url.get('dest')) {
        url.set('track_id', randomString(64))

        // -- attach another parameter to the url so we know later on that somebody visited bing directly from hennis
        url.set('direct', '1')
        window.history.replaceState(null, null, '?' + url.searchParams.toString()) // or pushState
    }

    new AutoComplete({
        element: html.querySelector('.search-box'),

        // -- set async function to populate search results
        data: {
            src: (new AutoSuggest().getSuggestions),
            keys: ['displayText'],
        },

        // -- transform received data
        transform: (results) => {

            results = findVal(results, 'suggestions') || []

            return results.map((result) => {
                return {
                    displayText: result,
                }
            })

            return results['suggestions'] || []
        },

        events: {
            onKeywordSelected: (keyword) => {

                // -- redirect user to search page as soon as some keyword is selected
                this.setKeyword(keyword, true)
            },
        },
    })

    this.getKeyword = function () {
        const keyword = url.get('q')

        if (!keyword || !keyword.trim()) {
            return null
        }

        return keyword
    }

    this.setKeyword = function (keyword, search) {

        if (keyword === null) {
            url.delete('q')
            return
        }

        url.set('q', keyword)

        if (search) {
            this.search()
        }
    }

    this.getLanguage = function (short = true) {

        let language = url.get('lang')

        if (!language) {
            language = 'en_US'
        }

        if (short) {
            return language.substring(0, 2)
        }
        return language
    }

    this.getPage = function () {

        const page = parseInt(url.get('p'))

        if (page > 0) {
            return page
        }

        return 1
    }

    this.search = function () {

        // -- if no query parameter is set, do not fire the search request
        if (!url.get('q') || !url.get('q').trim()) {
            return
        }

        url.pathname = '/search.html'
        window.location.href = url.href
    }

    // // -- @todo: once we implemented router logic such methods should be removed from this class
    this.redirect = function (to) {
        let redirectUrl = new UrlHelper(url.origin)
        let routeFound = false

        switch (to) {
            case 'home':
            case 'index':
                routeFound = true

                // -- we want to keep tracking url
                redirectUrl.append('track_id', url.searchParams.get('track_id'))
                redirectUrl.pathname = 'index.html'
                break
        }

        if (routeFound) {
            window.location.href = redirectUrl.toString()
        }
    }

    this.getTestModeFlag = function () {

        const autoTest = url.get('autotest')

        // -- whenever we pass autotest=1 via the url the monetization is disabled
        if (autoTest && autoTest.trim() === '1') {
            return 'ON'
        }

        // -- by default monetization is enabled (OFF)
        return 'OFF'
    }

    this.getTracingTag = function () {

        // -- tracing tag is also known as 'TypeTag'. Currently we're passing a campaign id as md5 hash to this page.
        // -- Later on we while fetching MS reports we can match the campaign id against this md5 hash
        const tracingTag = url.get('trace_id')

        if (tracingTag) {
            return tracingTag
        }

        // usage without 'trace_id' parameter is not allowed. So we will return some default value (tonic in reverse)
        return 'cinot'

    }

    this.getBraveResults = async function (query) {

        const params = {
            q: query
        };

        const response = await fetch(
            SEARCH_URL + "?" + new URLSearchParams(params));

        if (!response.ok) {
            const error = await response.text();
            throw new Error(error);
        }
        const data = await response.json();
        return data
    }
    // -- make the app available everywhere
    window['app'] = this
    window['url'] = url
    window['environment'] = new Environment()
    window['tracking'] = new Tracking()
    window['isMobile'] = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
}
